import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, timer, Subject } from 'rxjs';
import { IdleService } from 'cad/core/services/session/idle-service';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

@Injectable()
export class IdleInterceptor implements HttpInterceptor, OnDestroy {
  private readonly tickPeriod: number = 60000;
  private reset: BehaviorSubject<void> = new BehaviorSubject<void>(null);
  private unsub: Subject<void> = new Subject<void>();
  private readonly filteredUrlPatterns: string[] = [
    'logout',
    'login',
    'user-preference/active',
    'index.html',
    'proxy.html' ];

  constructor(private idleService: IdleService) {
    this.reset.pipe(takeUntil(this.unsub),switchMap(() => timer(0, this.tickPeriod)))
      .subscribe((tick) => this.idleService.idleSession(tick));
    // Reset the timer if keep Alive is emitted
    this.idleService.keepAliveSub.pipe(takeUntil(this.unsub))
    .subscribe(() => this.reset.next(null));
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(tap((event) => {
        if (event instanceof HttpResponse && !this.shouldBypass(event.url)) {
          this.reset.next(null);
        }
      }
    ));
  }

  private shouldBypass(url: string): boolean {
    for(let ignoreString of this.filteredUrlPatterns) {
      if (url.toLowerCase().includes(ignoreString.toLowerCase())) {
        return true;
      }
    }
    return false;
  }
}
